// Polyfill for requestIdleCallback (not supported in Safari)
if (typeof window !== 'undefined' && !window.requestIdleCallback) {
  window.requestIdleCallback = function (callback, options) {
    const start = Date.now();
    return setTimeout(function () {
      callback({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };
}

if (typeof window !== 'undefined' && !window.cancelIdleCallback) {
  window.cancelIdleCallback = function (id) {
    clearTimeout(id);
  };
}
